import styled from "styled-components";

export const FooterContainer = styled.footer`
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.15);
  position: fixed;
  bottom: 0;
`;
export const AddPatientContainer = styled.div`
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 910px) {
    width: 85%;
  }
  @media (max-width: 400px) {
    margin: 0;
  }
`;
